import React from 'react';
import { ReactDFPWrapper } from '../components/common/adverts/googleDFP/ReactDFPWrapper';
import DFPDynamicBanner from '../components/common/adverts/googleDFP/DFPDynamicBanner';
import { siteOfOriginHelper } from '../helpers/genericHelpers';

export default function DFPLayout(props) {

    const { pathname } = props;
    const siteOfOrigin = siteOfOriginHelper();

    const shouldShowBanner = () => {
        if ((localStorage.getItem('free_account') === "1") || (siteOfOrigin === 'us')) {
            return null;
        } else if (!pathname.includes('/consultancy')
            && !pathname.includes('/partnerships')
            && !pathname.includes('/media')
            && !pathname.includes('/expired')) {
            return <DFPDynamicBanner />;
        }
    }

    return (
            <div className="box-content">
                <ReactDFPWrapper adUnit={'PTL.NED'}>
                    {shouldShowBanner()}
                    {props.children}
                    {shouldShowBanner()}
                </ReactDFPWrapper>
            </div>
    );
}





// WEBPACK FOOTER //
// src/client/layouts/DFPLayout.js